// extracted by mini-css-extract-plugin
export default {"link":"place_link__4Sozl"};